import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ChangePasswordPayload } from '@ui/shared/models';

import {
  getResetPasswordActionState,
  Go,
  LogoComponent,
  MessageComponent,
  ResetPassword,
  ResetPasswordFail,
  SetPasswordFormComponent
} from '@ui/legacy-lib';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LogoComponent,
    TranslateModule,
    SetPasswordFormComponent,
    AsyncPipe,
    MessageComponent
  ]
})
export class ResetPasswordComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private store = inject(Store);

  public error$: Observable<string>;
  private token: string;

  ngOnInit() {
    this.token = this.route.snapshot.queryParams.token || '';
    this.error$ = this.store
      .select(getResetPasswordActionState)
      .pipe(
        map(actionState =>
          actionState.error ? actionState.error.message : null
        )
      );

    if (!this.token || (this.token && this.token.length === 0)) {
      this.store.dispatch(
        new Go({
          path: ['reset-password/request-reset']
        })
      );
    }
  }

  public submit(payload: ChangePasswordPayload): boolean {
    const token = this.token;
    const password = payload.password;
    const confirmedPassword = payload.confirmedPassword;

    if (!password || !confirmedPassword) {
      return;
    }

    if (!this.token) {
      this.store.dispatch(
        new ResetPasswordFail(new Error('ERR_MISSING_TOKEN'))
      );
      return false;
    }

    this.token = null;
    this.store.dispatch(
      new ResetPassword({ password, confirmedPassword, token })
    );
    return true;
  }
}
